import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import 'react-toggle/style.css';
import API from '../../../utils/API';
import TabContainer from '../../../components/views/TabsContainer';
import InputField from '../../../components/inputs/inputField';

import FormSubmissions from './submissions';
import ToggleField from '../../../components/inputs/toggleField';
import SelectField from '../../../components/inputs/selectField';
import SectionHeader from '../../../components/views/SectionHeader';
import PagePreviewFrame from '../../../views/pages/components/pagePreviewFrame';
import FormBuilderModal from './modals/formBuilder';
import SectionFooter from '../../../components/views/SectionFooter';

import DuplicateFormModal from './modals/duplicateFormModal'
import RichTextEditor from '../../../views/pages/components/richTextEditor';
import AddToPage from './modals/addToPage';
import CloseFormNowModal from './modals/closeFormNowModal';
import ScheduleCloseFormModal from './modals/scheduleCloseFormModal';
import RenameFormModal from './modals/renameFormModal';
import moment from 'moment';
import DeleteFormModal from './modals/deleteFormModal';
import ActionButtonContainer from '../../../components/views/ActionButtonContainer';
import DeleteSubmissionModal from './modals/deleteSubmissionModal';
import SedgwickConfigModal from './modals/sedgwickConfigModal';
import Joyride from 'react-joyride';
import tutorials from '../../../layouts/components/tutorials';
import LoadingWizard from '../../../components/spinner/wizard';
import AlertBar from '../../../components/custom/alertBar';

const ENV =
	process.env.NODE_ENV === 'production'
		? window.location.href.includes('planner.simple.events') ? `https://admin-api.simple.events/` : `https://beta-api.simple.events/`
		: `http://${window.location.hostname}:5015/`;
const baseFieldList = [
	{
		_id: 'attendee',
		title: 'Attendee Basic Detail Fields',
		fields: [
			{
				_id: '_firstName',
				fieldName: 'First Name',
				fieldType: 'text',
				required: true,
				propertyType: 'attendee'
			},
			{
				_id: '_lastName',
				fieldName: 'Last Name',
				fieldType: 'text',
				required: false,
				propertyType: 'attendee'
			},
			{
				_id: '_email',
				fieldName: 'Email',
				fieldType: 'email',
				required: true,
				propertyType: 'attendee'
			},
			{
				_id: '_bcc',
				fieldName: 'BCC',
				fieldType: 'text',
				required: false,
				propertyType: 'attendee',
			},
			{
				_id: '_phoneNumber',
				fieldName: 'Phone Number',
				fieldType: 'tel',
				required: false,
				propertyType: 'attendee'
			},
			{
				_id: '_title',
				fieldName: 'Title',
				fieldType: 'text',
				required: false,
				propertyType: 'attendee'
			},
			{
				_id: '_company',
				fieldName: 'Company',
				fieldType: 'text',
				required: false,
				propertyType: 'attendee'
			},
			{
				_id: '_textMessageOptIn',
				fieldName: 'Text Message Opt In',
				fieldType: 'checkbox',
				required: false,
				propertyType: 'attendee'
			},
			{
				_id: '_dietaryPreference',
				fieldName: 'Dietary Preference',
				fieldType: 'text',
				required: false,
				propertyType: 'attendee'
			},
			{
				_id: '_foodAllergies',
				fieldName: 'Food Allergies',
				fieldType: 'text',
				required: false,
				propertyType: 'attendee'
			},
			{
				_id: '_emergencyContactName',
				fieldName: 'Emergency Contact Name',
				fieldType: 'text',
				required: false,
				propertyType: 'attendee'
			},
			{
				_id: '_emergencyContactPhoneNumber',
				fieldName: 'Emergency Contact Phone Number',
				fieldType: 'tel',
				required: false,
				propertyType: 'attendee'
			},
			{
				_id: '_address',
				fieldName: 'Address',
				fieldType: 'text',
				required: false,
				propertyType: 'attendee'
			},
			{
				_id: '_address2',
				fieldName: 'Address 2',
				fieldType: 'text',
				required: false,
				propertyType: 'attendee'
			},
			{
				_id: '_city',
				fieldName: 'City',
				fieldType: 'text',
				required: false,
				propertyType: 'attendee'
			},
			{
				_id: '_state',
				fieldName: 'State',
				fieldType: 'text',
				required: false,
				propertyType: 'attendee'
			},
			{
				_id: '_zip',
				fieldName: 'Zip',
				fieldType: 'text',
				required: false,
				propertyType: 'attendee'
			},
			{
				_id: '_country',
				fieldName: 'Country',
				fieldType: 'text',
				required: false,
				propertyType: 'attendee'
			},
			{
				_id: '_profilePicture',
				fieldName: 'Profile Picture',
				fieldType: 'profileImage',
				required: false,
				propertyType: 'attendee'
			},
			{
				_id: '_NPINumber',
				fieldName: 'NPI Number',
				fieldType: 'NPINumber',
				required: false,
				propertyType: 'attendee'
			},

		]
	},
	{
		_id: 'rooming',
		title: 'Attendee Rooming Fields',
		fields: [
			{
				_id: '_roomingInformation-arrivalDate',
				fieldName: 'Arrival Date',
				fieldType: 'date',
				propertyType: 'attendee',
			}, {
				_id: '_roomingInformation-arrivalTime',
				fieldName: 'Arrival Time',
				fieldType: 'time',
				propertyType: 'attendee'
			}, {
				_id: '_roomingInformation-checkInDate',
				fieldName: 'Check In Date',
				fieldType: 'date',
				propertyType: 'attendee'
			}, {
				_id: '_roomingInformation-departureDate',
				fieldName: 'Departure Date',
				fieldType: 'date',
				propertyType: 'attendee'
			}, {
				_id: '_roomingInformation-departureTime',
				fieldName: 'Departure Time',
				fieldType: 'time',
				propertyType: 'attendee'
			}, {
				_id: '_roomingInformation-checkOutDate',
				fieldName: 'Check Out Date',
				fieldType: 'date',
				propertyType: 'attendee'
			}, {
				_id: '_roomingInformation-numberOfDaysStay',
				fieldName: 'Number of Nights',
				fieldType: 'number',
				propertyType: 'attendee'
			}, {
				_id: '_roomingInformation-roomType',
				fieldName: 'Room Type',
				fieldType: 'text',
				propertyType: 'attendee'
			}, {
				_id: '_roomingInformation-hotelConfirmationNumber',
				fieldName: 'Hotel Confirmation Number',
				fieldType: 'text',
				propertyType: 'attendee'
			}, {
				_id: '_roomingInformation-notes',
				fieldName: 'Notes',
				fieldType: 'text',
				propertyType: 'attendee'
			}
		]
	},
	{
		_id: 'travel',
		title: 'Attendee Travel Fields',
		fields: [
			{
				_id: '_travelInformation-originCity',
				fieldName: 'Origin City',
				fieldType: 'text',
				propertyType: 'attendee'
			}, {
				_id: '_travelInformation-originState',
				fieldName: 'Origin State',
				fieldType: 'text',
				propertyType: 'attendee'
			}, {
				_id: '_travelInformation-arrivalCity',
				fieldName: 'Arrival City',
				fieldType: 'text',
				propertyType: 'attendee'
			}, {
				_id: '_travelInformation-arrivalState',
				fieldName: 'Arrival State',
				fieldType: 'text',
				propertyType: 'attendee'
			}, {
				_id: '_travelInformation-arrivalDate',
				fieldName: 'Arrival Date',
				fieldType: 'date',
				propertyType: 'attendee'
			}, {
				_id: '_travelInformation-arrivalTime',
				fieldName: 'Arrival Time',
				fieldType: 'time',
				propertyType: 'attendee'
			}, {
				_id: '_travelInformation-arrivalCarrier',
				fieldName: 'Arrival Carrier',
				fieldType: 'text',
				propertyType: 'attendee'
			}, {
				_id: '_travelInformation-arrivalFlight',
				fieldName: 'Arrival Flight',
				fieldType: 'text',
				propertyType: 'attendee'
			}, {
				_id: '_travelInformation-arrivalTicketed',
				fieldName: 'Arrival Ticketed',
				fieldType: 'text',
				propertyType: 'attendee'
			}, {
				_id: '_travelInformation-arrivalClassOfService',
				fieldName: 'Arrival Class of Service',
				fieldType: 'text',
				propertyType: 'attendee'
			}, {
				_id: '_travelInformation-arrivalLocator',
				fieldName: 'Arrival Locator',
				fieldType: 'text',
				propertyType: 'attendee'
			}, {
				_id: '_travelInformation-departureCity',
				fieldName: 'Departure City',
				fieldType: 'text',
				propertyType: 'attendee'
			}, {
				_id: '_travelInformation-departureState',
				fieldName: 'Departure State',
				fieldType: 'text',
				propertyType: 'attendee'
			}, {
				_id: '_travelInformation-destinationCity',
				fieldName: 'Destination City',
				fieldType: 'text',
				propertyType: 'attendee'
			}, {
				_id: '_travelInformation-destinationState',
				fieldName: 'Destination State',
				fieldType: 'text',
				propertyType: 'attendee'
			}, {
				_id: '_travelInformation-departureDate',
				fieldName: 'Departure Date',
				fieldType: 'date',
				propertyType: 'attendee'
			}, {
				_id: '_travelInformation-departureTime',
				fieldName: 'Departure Time',
				fieldType: 'time',
				propertyType: 'attendee'
			}, {
				_id: '_travelInformation-departureCarrier',
				fieldName: 'Departure Carrier',
				fieldType: 'text',
				propertyType: 'attendee'
			}, {
				_id: '_travelInformation-departureFlight',
				fieldName: 'Departure Flight',
				fieldType: 'text',
				propertyType: 'attendee'
			}, {
				_id: '_travelInformation-departureTicketed',
				fieldName: 'Departure Ticketed',
				fieldType: 'text',
				propertyType: 'attendee'
			}, {
				_id: '_travelInformation-departureClassOfService',
				fieldName: 'Departure Class of Service',
				fieldType: 'text',
				propertyType: 'attendee'
			}, {
				_id: '_travelInformation-departureLocator',
				fieldName: 'Departure Locator',
				fieldType: 'text',
				propertyType: 'attendee'
			}]
	},
	{
		_id: 'special',
		title: 'Special Function Fields',
		fields: [
			{
				_id: '_additionalAttendees',
				fieldName: 'Additional Attendees',
				fieldType: 'additionalAttendees',
				propertyType: 'base',
				moduleConfiguration: {
					label: 'Guest',
					maxAttendees: 2,
					associatedGroup: null,
					defaultStatus: 'registered',
					confirmationEmail: null,
					fields: [
						{
							_id: '_firstName',
							attendeeField: { propertyType: 'base', propertyName: 'firstName' },
							columnClass: 'col-12',
							description: '',
							disabled: false,
							id: '_attendeeFirstName',
							label: 'First Name',
							objectClass: 'xbaseInput',
							options: [],
							placeholder: '',
							required: true,
							style: '',
							type: 'text',
							static: true
						},
						{
							_id: '_lastName',
							attendeeField: { propertyType: 'base', propertyName: 'lastName' },
							columnClass: 'col-12',
							description: '',
							disabled: false,
							id: '_attendeeLastName',
							label: 'Last Name',
							objectClass: 'xbaseInput',
							options: [],
							placeholder: '',
							required: false,
							style: '',
							type: 'text',
							static: false
						},
						{
							_id: '_email',
							attendeeField: { propertyType: 'base', propertyName: 'email' },
							columnClass: 'col-12',
							description: '',
							disabled: false,
							id: '_attendeeEmail',
							label: 'Email',
							objectClass: 'xbaseInput',
							options: [],
							placeholder: '',
							required: true,
							style: '',
							type: 'email',
							static: true
						}
					]
				}
			},
			{
				_id: '*notifierEmail',
				fieldName: 'Notifier Email',
				fieldType: 'notifierEmail',
				propertyType: 'custom',
				moduleConfiguration: {
					notificationEmail: null,
				}
			},
			{
				_id: '_medProLookup',
				fieldName: 'MedPro Lookup',
				fieldType: 'medProLookup',
				propertyType: 'base',
				moduleConfiguration: {
					"medProID": false,
					"medProMasterID": false,
					"firstName": false,
					"lastName": false,
					"suffix": false,
					"title": false,
					"address": false,
					"licenseNumber": false,
					"licenseState": false,
				}
			},
			{
				_id: '_salesForceSearchContact',
				fieldName: 'Salesforce Search Contact',
				fieldType: 'salesForceSearchContact',
				propertyType: 'base',
				moduleConfiguration: {
					"medProID": false,
					"medProMasterID": false,
					"firstName": false,
					"lastName": false,
					"suffix": false,
					"title": false,
					"address": false,
					"licenseNumber": false,
					"licenseState": false,
				}
			},
			{
				_id: '_salesForceSearchAccount',
				fieldName: 'Salesforce Search Account',
				fieldType: 'salesForceSearchAccount',
				propertyType: 'base',
				moduleConfiguration: {
					"medProID": false,
					"medProMasterID": false,
					"firstName": false,
					"lastName": false,
					"suffix": false,
					"title": false,
					"address": false,
					"licenseNumber": false,
					"licenseState": false,
				}
			},
			{
				_id: '*groupSelection',
				fieldName: 'Group Selection',
				fieldType: 'groupSelection',
				propertyType: 'custom',
				moduleConfiguration: {
				}
			},
			{
				_id: '*redirectToPage',
				fieldName: 'Redirect to Page',
				fieldType: 'redirectToPage',
				propertyType: 'custom',
				moduleConfiguration: {
				}
			},
			{
				_id: '_singleInventoryRedemption',
				fieldName: 'Single Inventory Redemption',
				fieldType: 'singleInventoryRedemption',
				propertyType: 'custom',
			},
			{
				_id: '*inventoryLookup',
				fieldName: 'Inventory Lookup',
				fieldType: 'inventoryLookup',
				propertyType: 'custom',
				moduleConfiguration: {
					"redeemable": false,
				}
			},
		]
	}
];
class Form extends Component {
	constructor(props) {
		super(props);
		this.state = {
			form: {},
			editedForm: {},
			formEditorModalOpen: false,
			eventId: props.eventId,
			editedFields: props.fields,
			customFields: this.props.fields.map((category) => {
				const title = category.title;
				const headers = category.fields.map((field) => {
					const name = field.fieldName;
					return {
						_id: field._id,
						fieldName: field.fieldName,
						fieldType: field.fieldType,
						category: title,
						categoryId: category._id,
						required: false,
						disabled: false,
						value: name,
						label: name,
						propertyType: 'attendee'
					};
				});
				return {
					_id: category._id,
					title: `${title}`,
					fields: headers,
					label: title,
					value: category._id,
					options: headers
				};
			}),
			metadataOptions: [],
			fieldModal: false,
			adding: false,
			loading: true,
			editing: false,
			editingFormBuilder: false,
			removing: false,
			removedCategoryId: 0,
			removedFieldId: 0,
			customFieldsCollapsed: false,
			unattachedFieldsCollapsed: true,
			formButtonsCollapsed: true,
			fieldTypeTabSelected: 0,
			pageCount: 0,
			currentPage: 0,
			formEditorTabSelected: 0,
			selectedSection: 'settings',
			pageEmbedOptions: [],
			selectedEmbedPage: 0,
			selectedEmbedPagePreview: {},
			toggleAddToPage: false,
			toggleDuplicateFormModal: false,
			pages: [],
			isV1: false,
			toggleRenameForm: false,
			editCount: 0,
			requiredFields: {
				campaignName: false,
				rsvpLabel: false,
			},
			isMissingFields: true,
			toggleScheduleClose: false,
			toggleCloseNow: false,
			toggleDeleteForm: false,
			editingSubmissions: false,
			clearSubmissionsFunction: () => { },
			checkedSubmission: {},
			runPageTutorial: false,
			allPages: [],
			formFieldOptions: [],
			formIntegrations: [],
			tabs: [],
			showSedgwickConfigModal: false,
			pendingSedgwickToggle: false,
			baseFieldList: [],
			inventory: []

		};
	}

	componentDidMount() {
		const { orgId, eventId, organization } = this.props;
		const { match: { params }, keyedData } = this.props;

		// Build tabs array once
		let tabs = [
			{
				title: <span>Settings</span>,
				id: 'settings'
			},
			{
				title: <span>Advanced</span>,
				id: 'advanced'
			}
		];

		// Check if there are enabled Form category integrations
		const formIntegrations = organization?.integrations?.filter(
			integration => integration.category === 'Form'
		);

		// Conditionally add integrations tab
		if (formIntegrations.length > 0) {
			tabs.push({
				title: <span>Integrations</span>,
				id: 'integrations'
			});
		}

		// Always add submissions tab at the end
		tabs.push({
			title: <span>Submissions</span>,
			id: 'submissions'
		});

		this.setState({ tabs, formIntegrations: formIntegrations });

		API().get(`Organizations/${orgId}/events/${eventId}/inventory`).then((res) => {
			if (res.data) {
				const inventory = res.data.inventory;
				this.setState({ inventory: inventory });
			}
		});

		API().get(`Organizations/${orgId}/events/${eventId}/forms/${params.formId}`).then((res) => {
			if (res.data) {
				const editForm = JSON.parse(JSON.stringify({ ...this.state.editedForm, ...res.data }));
				if (editForm.pages.length === 0) {
					editForm.pages = [
						{
							title: '',
							description: '',
							sections: [
								{
									_id: `^0`,
									title: '',
									page: 1,
									fields: [],
									buttons: []
								}
							]
						}
					];
				}
				let isV1 = false;
				if (editForm.pageEmbedOptions && editForm.pageEmbedOptions.length > 0) {
					isV1 = true;
				}
				let isMissingFields = true;
				const formFieldOptions = [];

				// Add attendee base fields
				const attendeeBaseFields = baseFieldList.find(bfl => bfl._id === 'attendee');
				if (attendeeBaseFields) {
					attendeeBaseFields.fields.forEach(field => {
						formFieldOptions.push({
							label: `[Attendee] ${field.fieldName}`,
							value: `attendee.${field._id.substring(1)}`, // Remove underscore prefix
							type: 'attendee'
						});
					});
				}

				// Add rooming fields
				const roomingFields = baseFieldList.find(bfl => bfl._id === 'rooming');
				if (roomingFields) {
					roomingFields.fields.forEach(field => {
						formFieldOptions.push({
							label: `[Attendee] ${field.fieldName}`,
							value: `attendee.${field._id.substring(1)}`, // Remove underscore prefix
							type: 'attendee'
						});
					});
				}

				// Add travel fields
				const travelFields = baseFieldList.find(bfl => bfl._id === 'travel');
				if (travelFields) {
					travelFields.fields.forEach(field => {
						formFieldOptions.push({
							label: `[Attendee] ${field.fieldName}`,
							value: `attendee.${field._id.substring(1)}`, // Remove underscore prefix
							type: 'attendee'
						});
					});
				}

				// Add custom fields
				this.props.fields.forEach(category => {
					category.fields.forEach(field => {
						formFieldOptions.push({
							label: `[Custom] ${category.title} - ${field.fieldName}`,
							value: `custom.${field._id}`,
							type: 'custom'
						});
					});
				});

				// Traverse pages -> sections -> fields -> nestedSections -> questions for form fields
				if (editForm.pages && editForm.pages.length > 0) {
					for (let pageCount = 0; pageCount < editForm.pages.length; pageCount++) {
						let page = editForm.pages[pageCount];
						if (page.sections && page.sections.length > 0) {
							for (let sectionCount = 0; sectionCount < page.sections.length; sectionCount++) {
								let section = page.sections[sectionCount];
								if (section.fields && section.fields.length > 0) {
									for (let fieldCount = 0; fieldCount < section.fields.length; fieldCount++) {
										let field = section.fields[fieldCount];

										// Add the main field
										formFieldOptions.push({
											label: `[Form] ${field.label}`,
											value: `form.${field.id || field._id}`,
											type: 'form'
										});

										// Check for nested sections and their questions
										if (field.nestedSections && field.nestedSections.length > 0) {
											for (let nsCount = 0; nsCount < field.nestedSections.length; nsCount++) {
												let nestedSection = field.nestedSections[nsCount];
												if (nestedSection.questions && nestedSection.questions.length > 0) {
													for (let qCount = 0; qCount < nestedSection.questions.length; qCount++) {
														let question = nestedSection.questions[qCount];
														formFieldOptions.push({
															label: `[Form] ${field.label} - ${question.label}`,
															value: `form.${field.id || field._id}*${question.id || question._id}`,
															type: 'form'
														});
													}
												}
											}
										}
									}
									isMissingFields = false;
								}
							}
						}
					}
				}

				this.setState({
					isMissingFields: isMissingFields,
					form: { ...this.state.form, ...res.data },
					editedForm: editForm,
					loading: false,
					isV1: isV1,
					pageEmbedOptions: editForm.pageEmbedOptions.map((option) => {
						return {
							label: option.title,
							value: option._id,
							partials: option.partials,
							url: option.url

						};
					}),
					pageEmbedOptionsV2: editForm.pageEmbedOptionsV2.map((option) => {
						return {
							label: option.title,
							value: option._id,
							partials: option.partials,
							url: option.url
						};
					}),
					selectedEmbedPageV1: editForm.pageEmbedOptions.length > 0 ? editForm.pageEmbedOptions[0]._id : 0,
					selectedEmbedPage: editForm.pageEmbedOptionsV2.length > 0 ? editForm.pageEmbedOptionsV2[0]._id : 0,
					formFieldOptions: formFieldOptions
				}, () => {
					const selectedEmbedPagePreview = this.state.pageEmbedOptionsV2.find((option) => option.value == this.state.selectedEmbedPage);
					const selectedEmbedPagePreviewV1 = this.state.pageEmbedOptions.find((option) => option.value == this.state.selectedEmbedPageV1);
					this.setState({ selectedEmbedPagePreview: selectedEmbedPagePreview, selectedEmbedPagePreviewV1: selectedEmbedPagePreviewV1 });

					// Compute filtered baseFieldList after state is set
					const hasIntegrations = Object.keys(this.props.event.integrations || {}).length > 0;
					const filteredBaseFieldList = baseFieldList.map(category => {  // Use the original constant here
						if (category._id === 'attendee') {
							return {
								...category,
								fields: category.fields.filter(field => field._id !== '_NPINumber' || hasIntegrations)
							};
						}
						return category;
					});
					this.setState({ baseFieldList: filteredBaseFieldList });  // Set to state
				});
			}
		});
		API().get(`Organizations/${orgId}/events/${eventId}/formPages`).then((res) => {
			if (res.data) {
				let fixedPages = res.data.pages.map((page) => {
					return {
						label: page.title,
						value: page._id
					};
				});
				this.setState({ pages: fixedPages, allPages: res.data.allPages });
			}
		});


		const metadataOptions = [];
		keyedData &&
			Object.keys(keyedData).forEach((key) => {
				const layer1 = keyedData[key];
				if (typeof layer1 === 'object') {
					Object.keys(layer1).forEach((key2) => {
						const layer2 = layer1[key2];
						const k2 = key2.substring(0, 1) + key2.substring(1);
						if (typeof layer2 === 'object') {
							Object.keys(layer2).forEach((key3) => {
								const layer3 = layer2[key3];
								const k3 = key3.substring(0, 1) + key3.substring(1);
								if (
									key !== '_defaultLabel' &&
									key2 !== '_defaultLabel' &&
									key3 !== '_defaultLabel'
								) {
									//metadataOptions.push(`${key}.${key2}.${key3}`);
									metadataOptions.push({
										label: `${layer1._defaultLabel} ${layer2._defaultLabel} ${layer3}`,
										value: `{{${key}${k2}${k3}}}`,
										text: `${key}${k2}${k3}`
									});
								}
							});
						} else {
							if (key !== '_defaultLabel' && key2 !== '_defaultLabel') {
								//metadataOptions.push(`${key}.${key2}`);
								metadataOptions.push({
									label: `${layer1._defaultLabel} ${layer2}`,
									value: `{{${key}${k2}}}`,
									text: `${key}${k2}`
								});
							}
						}
					});
				} else {
					if (key !== '_defaultLabel') {
						metadataOptions.push({ label: layer1, value: key, text: `{{${key}}}` });
					}
				}
			});
		this.setState({ metadataOptions: metadataOptions });
	}

	deleteFormSubmission = async (callback) => {
		const { eventId, orgId } = this.props;
		const { form, editedForm, editingSubmissions, checkedSubmission } = this.state;


		if (editingSubmissions && Object.keys(checkedSubmission).length > 0) {
			await API()
				.patch(`Organizations/${orgId}/events/${eventId}/forms/${form._id}`, {
					deletedSubmissions: Object.keys(checkedSubmission)
				})
				.then((res) => {
					if (res.data) {
						const editForm = JSON.parse(JSON.stringify({ ...editedForm, ...res.data }));
						let isMissingFields = true;
						if (editForm.pages && editForm.pages.length > 0) {
							for (let pageCount = 0; pageCount < editForm.pages.length; pageCount++) {
								let page = editForm.pages[pageCount];
								if (page.sections && page.sections.length > 0) {
									for (let sectionCount = 0; sectionCount < page.sections.length; sectionCount++) {
										let section = page.sections[sectionCount];
										if (section.fields && section.fields.length > 0) {
											isMissingFields = false;
											break;
										}
									}

								}
								if (isMissingFields == false) {
									break;

								}

							}

						}
						this.state.clearSubmissionsFunction();
						this.setState({
							form: { ...editedForm, ...res.data },
							editedForm: editForm,
							editing: false,
							editingFormBuilder: false,
							formEditorTabSelected: 0,
							focusOnField: false,
							focusedFieldId: null,
							focusedSectionId: null,
							editCount: this.state.editCount + 1,
							isMissingFields: isMissingFields,
							checkedSubmission: {},
							editingSubmissions: false

						}, () => {
							this.props.updateForm(this.state.form);
							callback && callback();

						});
					}
				})
				.catch((e) => {
					console.log(e);
				});

		}
	};

	saveForm = async () => {
		const { eventId, orgId } = this.props;
		const { editedForm, requiredFields } = this.state;

		let valid = true;

		if (editedForm.rsvpEnabled && !editedForm.rsvpLabel) {
			requiredFields.rsvpLabel = true;
			valid = false;
		} else {
			requiredFields.rsvpLabel = false;
		}

		if (!valid) {
			this.setState({ requiredFields: requiredFields });
			return;
		}


		let editedFormTemp = JSON.parse(JSON.stringify(editedForm));
		if (editedForm.confirmationEmail === 'N/A' || editedForm.confirmationEmail === '') {
			delete editedFormTemp.confirmationEmail;
		}
		delete editedFormTemp.submissions;


		await API()
			.patch(`Organizations/${orgId}/events/${eventId}/forms/${editedForm._id}`, editedFormTemp)
			.then((res) => {
				if (res.data) {
					const editForm = JSON.parse(JSON.stringify({ ...this.state.editedForm, ...res.data }));
					let isMissingFields = true;
					if (editForm.pages && editForm.pages.length > 0) {
						for (let pageCount = 0; pageCount < editForm.pages.length; pageCount++) {
							let page = editForm.pages[pageCount];
							if (page.sections && page.sections.length > 0) {
								for (let sectionCount = 0; sectionCount < page.sections.length; sectionCount++) {
									let section = page.sections[sectionCount];
									if (section.fields && section.fields.length > 0) {
										isMissingFields = false;
										break;
									}
								}

							}
							if (isMissingFields == false) {
								break;

							}

						}

					}

					this.setState({
						form: { ...this.state.editedForm, ...res.data },
						editedForm: editForm,
						editing: false,
						editingFormBuilder: false,
						formEditorTabSelected: 0,
						focusOnField: false,
						focusedFieldId: null,
						focusedSectionId: null,
						editCount: this.state.editCount + 1,
						isMissingFields: isMissingFields,
						requiredFields: { ...this.state.requiredFields, rsvpLabel: false }
					}, () => {
						this.props.updateForm(this.state.form);
					});
				}
			})
			.catch((e) => {
				this.setState({
					invalid: true,
					submitting: false
				});
			});
	};

	cancelSubmissionEdit = () => {
		const { editingSubmissions } = this.state;
		if (editingSubmissions) {
			this.setState({ editingSubmissions: false, checkedSubmission: {} }, () => {
				this.state.clearSubmissionsFunction();
			});
		}
	}

	cancelEdit = () => {
		const revertedForm = JSON.parse(JSON.stringify(this.state.form));
		this.setState({
			editedForm: revertedForm,
			editingFormBuilder: false,
			editing: false,
		});
	};

	updateSelected = (selectedIndex, tabId) => {
		const revertedForm = JSON.parse(JSON.stringify(this.state.form));
		this.setState({
			editedForm: revertedForm,
			editing: false,
			selectedSection: tabId,
			checkedSubmission: {},
			editingSubmissions: false,
			clearSubmissionsFunction: () => { }
		});
	};

	removePage = (index) => {
		const { editedForm, currentPage } = this.state;
		editedForm.pages.splice(index, 1);
		const cp = currentPage > editedForm.pages.length - 1 ? editedForm.pages.length - 1 : currentPage;
		this.setState({ editedForm: editedForm, currentPage: cp, editing: true });
	};

	updateForm = (editedForm) => {
		this.setState({
			editedForm: editedForm,
			editingFormBuilder: true
		});
	};

	handleChange = (changeObj) => {
		const { editedForm } = this.state;
		this.setState({ editedForm: { ...editedForm, ...changeObj }, editing: true });
	};

	toggleFormEditorModal = () => {
		this.setState({ formEditorModalOpen: !this.state.formEditorModalOpen });
	};

	updateAddToPage = (page, callback) => {
		let pageEmbedOptionsV2 = [...this.state.pageEmbedOptionsV2, {
			label: page.title,
			value: page._id,
			partials: page.partials,
			url: '',
			_id: page._id
		}];

		let selectedEmbedPage = pageEmbedOptionsV2.length > 0 ? pageEmbedOptionsV2[0]._id : 0;

		const selectedEmbedPagePreview = pageEmbedOptionsV2.find((option) => option.value == selectedEmbedPage);
		this.props.updatePathOptions(page);
		this.setState({ selectedEmbedPagePreview: selectedEmbedPagePreview, pageEmbedOptionsV2: pageEmbedOptionsV2, selectedEmbedPage: selectedEmbedPage },
			() => {
				callback && callback();
			});
	}

	updateFormName = (name, callback) => {
		const { editedForm, form } = this.state;

		this.setState({ editedForm: { ...editedForm, name: name }, form: { ...form, name: name } }, () => {
			this.props.updateForm(this.state.form);
			callback && callback();
		});
	}

	toggleSubmissionEditing = (isEditing, checkedSubmission, clearSubmissionsFunction) => {
		this.setState({ editingSubmissions: isEditing, checkedSubmission: checkedSubmission || {}, clearSubmissionsFunction: clearSubmissionsFunction || (() => { }) });
	}

	updateCustomFields = (customFieldData) => {
		const updatedCustomFields = [...this.state.customFields];

		// Find if category already exists
		const existingCategoryIndex = updatedCustomFields.findIndex(
			category => category.title === customFieldData.title
		);

		if (existingCategoryIndex > -1) {
			// Add new field to existing category
			const newField = {
				_id: customFieldData.fields[customFieldData.fields.length - 1]._id,
				fieldName: customFieldData.fields[customFieldData.fields.length - 1].fieldName,
				fieldType: customFieldData.fields[customFieldData.fields.length - 1].fieldType,
				required: false,
				disabled: false,
				propertyType: 'attendee'
			};
			updatedCustomFields[existingCategoryIndex].fields.push(newField);
		} else {
			const newCategory = {
				_id: 'custom',
				title: customFieldData.title,
				fields: customFieldData.fields.map((field) => ({
					_id: field._id,
					fieldName: field.fieldName,
					fieldType: field.fieldType,
					required: false,
					disabled: false,
					propertyType: 'attendee'
				}))
			};
			updatedCustomFields.push(newCategory);
		}

		this.setState({ customFields: updatedCustomFields });
	};


	renderSettingsSection = () => {
		const { editedForm, isMissingFields, isV1, pageEmbedOptions, selectedEmbedPageV1, pageEmbedOptionsV2, selectedEmbedPage } = this.state;
		const { orgId, eventId } = this.props;

		const selectedEmbedPagePreview = isV1 ? pageEmbedOptions.find((option) => option.value == selectedEmbedPageV1) : pageEmbedOptionsV2.find((option) => option.value == selectedEmbedPage);

		const formTypes = [
			{ value: 'registration', label: 'Registration' },
			{ value: 'general', label: 'General' }
		];

		return (
			<div className='blocksContainer-Advanced'>
				<div className="sectionBlock mr-25 contained-form">
					<h2 className='blockHeader'>Basic Information</h2>
					<SelectField
						label={'Form Type'}
						type="select"
						required={true}
						value={formTypes.find((type) => type.value == editedForm.type)}
						onChange={(e) => {
							this.handleChange({ type: e.value });
						}}
						options={formTypes}
					/>
					<ToggleField
						label="Enable Attendance Confirmation"
						checked={editedForm.rsvpEnabled}
						icons={false}
						onChange={(e) => {
							this.handleChange({ rsvpEnabled: e.target.checked });
						}}
					/>

					{editedForm.type == 'registration' && <ToggleField
						label="Allow Anonymous Submissions"
						checked={editedForm.allowAnonymous}
						icons={false}
						onChange={(e) => {
							this.handleChange({ allowAnonymous: e.target.checked });
						}}
					/>}
					{editedForm.type == 'registration' && <ToggleField
						label="Auto Login From Registration"
						checked={editedForm.autoLoginFromRegistration}
						icons={false}
						onChange={(e) => {
							this.handleChange({ autoLoginFromRegistration: e.target.checked });
						}}
					/>}

					{editedForm.type == 'registration' && <ToggleField
						label="Limit to One Submission Per Attendee"
						checked={editedForm.limitOneSubmission}
						icons={false}
						onChange={(e) => {
							this.handleChange({ limitOneSubmission: e.target.checked });
						}}
					/>}

					{/* editedForm.allowAnonymous && <SelectField
									label="Anonymous Submission Field"
									options={this.state.formFieldOptions}
									value={this.state.formFieldOptions.find(
										(e) => e.value == editedForm.anonymousSubmissionField
									)}
									onChange={(e) => {
										this.handleChange({ anonymousSubmissionField: e.value });
									}}
								/> */}

					{editedForm.rsvpEnabled &&

						<InputField
							label="Submit Button Label"
							required={true}
							placeholder="Register for Event"
							value={editedForm.rsvpLabel}
							errorTrigger={this.state.requiredFields.rsvpLabel}
							onChange={(e) => {
								this.handleChange({ rsvpLabel: e.target.value });
							}}
						/>
					}
					<h2 className='blockHeader'>Submission</h2>
					<InputField
						label="Confirmation Page Title"
						required={false}
						placeholder="Form Submitted"
						value={editedForm.successTitle}
						onChange={(e) => {
							this.handleChange({ successTitle: e.target.value });
						}}
					/>
					<RichTextEditor
						id="Confirmation_Page_Description"
						label="Confirmation Page Description"
						placeholder="We have received your information"
						value={editedForm.successSubtitle}
						defaultHeight={5}
						onChange={(e) => {
							this.handleChange({ successSubtitle: e });
						}}
						customFields={this.state.metadataOptions}

					/>

					<ToggleField
						label="Send Confirmation Email"
						checked={editedForm.confirmationEmailEnabled}
						icons={false}
						onChange={(e) => {
							this.handleChange({ confirmationEmailEnabled: e.target.checked });
						}}
					/>
					{editedForm.confirmationEmailEnabled && (
						<SelectField
							label="Confirmation Email Template"
							options={this.props.availableEmails}
							value={this.props.availableEmails.find(
								(e) => e.value == editedForm.confirmationEmail
							)}
							onChange={(e) => {
								this.handleChange({ confirmationEmail: e.value });
							}}
						/>
					)}
					<ToggleField
						label="Send Additional Attendee Confirmation Email"
						checked={editedForm.additionalAttendeeConfirmationEmailEnabled}
						icons={false}
						onChange={(e) => {
							this.handleChange({ additionalAttendeeConfirmationEmailEnabled: e.target.checked });
						}}
					/>
					{editedForm.additionalAttendeeConfirmationEmailEnabled && (
						<SelectField
							label="Additional Attendee Confirmation Email Template"
							options={this.props.availableEmails}
							value={this.props.availableEmails.find(
								(e) => e.value == editedForm.additionalAttendeeConfirmationEmail
							)}
							onChange={(e) => {
								this.handleChange({ additionalAttendeeConfirmationEmail: e.value });
							}}
						/>
					)}

				</div>
				<div style={{ padding: 5, minWidth: 490 }} className='sectionBlock contained-h emailDesignPreview mt-20 '>
					<div
						style={{ width: 590, maxWidth: "calc(100% - 15px)", minWidth: "calc(100% - 700px)", }}
						className="cardDetailsContainerPages containerTitle"
					>
						<div className='w-100'>
							<h2 className='blockHeader mt-0'>Design</h2>
							<h5 className='formFieldLabel mt-10'>Form Preview </h5>
						</div>

						{!isMissingFields ? <button
							className="neu ml-a"
							onClick={this.toggleFormEditorModal}
						>
							Edit Form
						</button> : <button
							className="neu prim ml-a"
							onClick={this.toggleFormEditorModal}
						>Add Form Fields
						</button>}
					</div>
					<div style={{ width: 590, maxWidth: "calc(100% - 15px)", minWidth: "calc(100% - 700px)", height: 500 }}>
						<div className="emailPreview eFrame pages flex-ac preview">
							<PagePreviewFrame
								ENV={ENV}
								key={this.state.editCount}
								renderURL={`${isV1 ? `Organizations/${orgId}/events/${eventId}/pages/render/${selectedEmbedPageV1}/` : `Organizations/${orgId}/events/${eventId}/pages/render/formRender/`}`}
								pageProperties={isV1 ? selectedEmbedPagePreview : {}}
								focusedComponent={""}
								simulatedUser={{ value: this.props.account._id }}
								simulatedSession={{ value: false }}
								renderOnly={true}
								formId={isV1 ? null : editedForm._id}
								preview={true}
							/>
						</div>
					</div>
				</div>
			</div>
		);
	};

	renderAdvancedSection = () => {
		const { editedForm, isMissingFields, isV1, pageEmbedOptions, selectedEmbedPageV1, pageEmbedOptionsV2, selectedEmbedPage } = this.state;
		const { orgId, eventId } = this.props;

		const selectedEmbedPagePreview = isV1 ? pageEmbedOptions.find((option) => option.value == selectedEmbedPageV1) : pageEmbedOptionsV2.find((option) => option.value == selectedEmbedPage);

		return (
			<div className='blocksContainer-Advanced'>
				<div className="sectionBlock mr-25 contained-Advanced">
					<h2 className='blockHeader'>Form Information</h2>
					<ToggleField
						label="Pre-fill form with attendee data"
						checked={editedForm.preFillAttendeeData}
						icons={false}
						onChange={(e) => {
							this.handleChange({ preFillAttendeeData: e.target.checked });
						}}
					/>



					<ToggleField
						label="Show Progress Bar"
						checked={editedForm.progressBarEnabled}
						icons={false}
						onChange={(e) => {
							this.handleChange({ progressBarEnabled: e.target.checked });
						}}
					/>


					<ToggleField
						label="Enable a review page before form submission"
						checked={editedForm.enableSubmissionReview}
						icons={false}
						onChange={(e) => {
							this.handleChange({ enableSubmissionReview: e.target.checked });
						}}
					/>

					{editedForm.enableSubmissionReview &&
						<div>
							<InputField
								label="Review Page Title"
								required={false}
								placeholder="Please Review"
								value={editedForm.submissionReviewTitle}
								onChange={(e) => {
									this.handleChange({ submissionReviewTitle: e.target.value });
								}}
							/>
							{/* Update */}
							<RichTextEditor
								id="Review_Page_Description"
								label="Review Page Description"
								placeholder="Look over your questions and go back if you need to edit."
								value={editedForm.submissionReviewSubtitle}
								onChange={(e) => {
									this.handleChange({ submissionReviewSubtitle: e });
								}}
								customFields={this.state.metadataOptions}
							/>
						</div>
					}

					<ToggleField
						label="Enable Captcha"
						checked={editedForm.captchaEnabled}
						icons={false}
						onChange={(e) => {
							this.handleChange({ captchaEnabled: e.target.checked });
						}}
					/>

					<ToggleField
						label="Enable Address Validation"
						checked={editedForm.validateAddress}
						icons={false}
						alert={"Full address must be collected in the form for validation to work. (Address, Address 2, City, State, Zip)"}
						onChange={(e) => {
							this.handleChange({ validateAddress: e.target.checked });
						}}
					/>

					{editedForm.rsvpEnabled && (
						<>
							<h2 className='blockHeader'>Decline Attendance</h2>
							<ToggleField
								label="Allow attendees to decline attendance"
								checked={editedForm.denialEnabled}
								icons={false}
								onChange={(e) => {
									this.handleChange({ denialEnabled: e.target.checked });
								}}
							/>
						</>
					)}

					{editedForm.rsvpEnabled && editedForm.denialEnabled &&
						<div>
							<InputField
								label="Decline Button Label"
								required={false}
								placeholder="I am unable to attend"
								value={editedForm.declineLabel}
								onChange={(e) => {
									this.handleChange({ declineLabel: e.target.value });
								}}
							/>

							<InputField
								label="Decline Page Title"
								required={false}
								placeholder="Sorry we missed you"
								value={editedForm.declineTitle}
								onChange={(e) => {
									this.handleChange({ declineTitle: e.target.value });
								}}
							/>

							<RichTextEditor
								id="Decline_Page_Description"
								label="Decline Page Description"
								placeholder="Not attending"
								value={editedForm.declineSubtitle}
								onChange={(e) => {
									this.handleChange({ declineSubtitle: e });
								}}
								customFields={this.state.metadataOptions}

							/>


							<ToggleField
								label="Enable Decline Options"
								checked={editedForm.enableDeclineOptions}
								icons={false}
								onChange={(e) => {
									this.handleChange({ enableDeclineOptions: e.target.checked });
								}}
							/>

							{editedForm.enableDeclineOptions && (
								<div className="pb-20">
									<div className="formFieldLabel">Decline Options</div>
									{editedForm.declineOptions.map((option, index) => {
										return (
											<div className='flex-ac'>
												<InputField
													label="Item"
													required={false}
													placeholder="Not attending"
													value={option}
													onChange={(e) => {
														editedForm.declineOptions[index] = e.target.value;
														this.handleChange({ declineOptions: editedForm.declineOptions });
													}}
												/>
												<i className='las la-times ml-10' onClick={() => {
													editedForm.declineOptions.splice(index, 1);
													this.handleChange({ declineOptions: editedForm.declineOptions });
												}}></i>
											</div>
										)
									})}

									<div className="c-pointer flex jcc" onClick={() => {
										editedForm.declineOptions.push('');
										this.handleChange({ declineOptions: editedForm.declineOptions });
									}}>+ Add Decline Options</div>
								</div>
							)

							}

							<ToggleField
								label="Require Decline Options"
								checked={editedForm.requireDeclineOptions}
								icons={false}
								onChange={(e) => {
									this.handleChange({ requireDeclineOptions: e.target.checked });
								}}
							/>

							<ToggleField
								label="Include Decline Comment"
								checked={editedForm.enableDeclineComment}
								icons={false}
								onChange={(e) => {
									this.handleChange({ enableDeclineComment: e.target.checked });
								}}
							/>

							{editedForm.enableDeclineComment &&
								<ToggleField
									label="Require Decline Comment"
									checked={editedForm.requireComment}
									icons={false}
									onChange={(e) => {
										this.handleChange({ requireComment: e.target.checked });
									}}
								/>
							}

						</div>

					}

					{editedForm.type == 'registration' &&
						<>
							<h2 className='blockHeader'>Attendee</h2>

							<ToggleField
								label="Add attendees to a group"
								checked={editedForm.enableGrouping}
								icons={false}
								onChange={(e) => {
									this.handleChange({ enableGrouping: e.target.checked });
								}}
							/>
							{editedForm.enableGrouping &&
								<div>
									<SelectField
										label="Attendee Group"
										options={this.props.groups}
										value={this.props.groups.find(
											(e) => e.value == editedForm.mappedGroup
										)}
										onChange={(e) => {
											this.handleChange({ mappedGroup: e.value });
										}}
									/>

									<RichTextEditor
										id="Max_Capacity_Title"
										label="Max Capacity Title"
										placeholder="Registration is at capacity"
										value={editedForm.maxCapTitle}
										onChange={(e) => {
											this.handleChange({ maxCapTitle: e });
										}}
										customFields={this.state.metadataOptions}
									/>

									<RichTextEditor
										id="Max_Capacity_Message"
										label="Max Capacity Message"
										placeholder="This registration has reached capacity"
										value={editedForm.maxCapacityMessage}
										onChange={(e) => {
											this.handleChange({ maxCapacityMessage: e });
										}}
										customFields={this.state.metadataOptions}

									/>
								</div>
							}
						</>
					}

					{editedForm.type == 'general' && (
						<>
							<ToggleField
								label="Limit Submissions"
								checked={editedForm.limitSubmissionsEnabled}
								icons={false}
								onChange={(e) => {
									this.handleChange({ limitSubmissionsEnabled: e.target.checked });
								}}
							/>
							{editedForm.limitSubmissionsEnabled && (
								<>
									<h2 className='blockHeader'>Capacity</h2>

									<InputField
										label="Maximum Submissions Allowed"
										type="number"
										required={false}
										placeholder="Enter maximum number of submissions"
										value={editedForm.limitSubmissions ?? 0}
										min={0}
										onChange={(e) => {
											const val = parseInt(e.target.value);
											this.handleChange({ limitSubmissions: isNaN(val) || val < 0 ? 0 : val });
										}}
									/>
									<RichTextEditor
										id="Max_Capacity_Title"
										label="Max Capacity Title"
										placeholder="Registration is at capacity"
										value={editedForm.maxCapTitle}
										onChange={(e) => {
											this.handleChange({ maxCapTitle: e });
										}}
										customFields={this.state.metadataOptions}
									/>
									<RichTextEditor
										id="Max_Capacity_Message"
										label="Max Capacity Message"
										placeholder="This registration has reached capacity"
										value={editedForm.maxCapacityMessage}
										onChange={(e) => {
											this.handleChange({ maxCapacityMessage: e });
										}}
										customFields={this.state.metadataOptions}
									/>
								</>
							)}
						</>
					)}
					
					<h2 className='blockHeader'>Form Messages</h2>
					<InputField
						label="Form Closed Title"
						required={false}
						placeholder="Form unavailable"
						value={editedForm.formClosedTitle}
						onChange={(e) => {
							this.handleChange({ formClosedTitle: e.target.value });
						}}
					/>

					<InputField
						label="Form Closed Message"
						required={false}
						placeholder="This form is not currently available, check back at a later time or reach out to support."
						value={editedForm.formClosedMessage}
						onChange={(e) => {
							this.handleChange({ formClosedMessage: e.target.value });
						}}
					/>

				</div>
				<div style={{ padding: 5, minWidth: 490 }} className='sectionBlock contained-h emailDesignPreview mt-20 '>
					<div
						style={{ width: 590, maxWidth: "calc(100% - 15px)", minWidth: "calc(100% - 700px)", }}
						className="cardDetailsContainerPages containerTitle"
					>
						<div className='w-100'>
							<h2 className='blockHeader mt-0'>Design</h2>
							<h5 className='formFieldLabel mt-10'>Form Preview </h5>
						</div>

						{!isMissingFields ? <button
							className="neu ml-a"
							onClick={this.toggleFormEditorModal}
						>
							Edit Form
						</button> : <button
							className="neu prim ml-a"
							onClick={this.toggleFormEditorModal}
						>Add Form Fields
						</button>}
					</div>
					<div style={{ width: 590, maxWidth: "calc(100% - 15px)", minWidth: "calc(100% - 700px)", height: 500 }}>
						<div className="emailPreview eFrame pages flex-ac preview">
							<PagePreviewFrame
								ENV={ENV}
								key={this.state.editCount}
								renderURL={`${isV1 ? `Organizations/${orgId}/events/${eventId}/pages/render/${selectedEmbedPageV1}/` : `Organizations/${orgId}/events/${eventId}/pages/render/formRender/`}`}
								pageProperties={isV1 ? selectedEmbedPagePreview : {}}
								focusedComponent={""}
								simulatedUser={{ value: this.props.account._id }}
								simulatedSession={{ value: false }}
								renderOnly={true}
								formId={isV1 ? null : editedForm._id}
								preview={true}
							/>
						</div>
					</div>
				</div>
			</div>
		);
	};

	handleIntegrationFieldMapping = (integrationName, fieldPath, formFieldId) => {
		const { editedForm } = this.state;
		const integrationSettings = { ...editedForm.integrationSettings } || {};

		if (!integrationSettings[integrationName]) {
			integrationSettings[integrationName] = { enabled: false, registrationPayload: {} };
		}

		if (!integrationSettings[integrationName].registrationPayload) {
			integrationSettings[integrationName].registrationPayload = {};
		}

		// Handle nested paths like ExtendedProperties.JobTitle
		const pathParts = fieldPath.split('.');
		if (pathParts.length > 1) {
			if (!integrationSettings[integrationName].registrationPayload[pathParts[0]]) {
				integrationSettings[integrationName].registrationPayload[pathParts[0]] = {};
			}
			integrationSettings[integrationName].registrationPayload[pathParts[0]][pathParts[1]] = formFieldId;
		} else {
			integrationSettings[integrationName].registrationPayload[fieldPath] = formFieldId;
		}

		this.handleChange({ integrationSettings });
	};

	toggleSedgwickConfigModal = () => {
		this.setState(prevState => ({
			showSedgwickConfigModal: !prevState.showSedgwickConfigModal,
			pendingSedgwickToggle: false
		}));
	};

	handleSedgwickToggle = (isEnabled) => {
		if (isEnabled) {
			// When enabling, show the config modal
			this.setState({
				showSedgwickConfigModal: true,
				pendingSedgwickToggle: true
			});
		} else {
			// When disabling, just turn it off
			const { editedForm } = this.state;
			const newIntegrationSettings = {
				...editedForm.integrationSettings,
				sedgwick: {
					enabled: false,
					registrationPayload: editedForm.integrationSettings?.sedgwick?.registrationPayload || {}
				}
			};
			this.handleChange({ integrationSettings: newIntegrationSettings });
		}
	};

	applySedgwickConfig = (newConfig) => {
		const { editedForm } = this.state;
		const newIntegrationSettings = {
			...editedForm.integrationSettings,
			sedgwick: {
				enabled: true,
				registrationPayload: newConfig
			}
		};
		this.handleChange({ integrationSettings: newIntegrationSettings });
		this.toggleSedgwickConfigModal();
	};

	skipSedgwickConfig = () => {
		const { editedForm } = this.state;
		const newIntegrationSettings = {
			...editedForm.integrationSettings,
			sedgwick: {
				enabled: true,
				registrationPayload: editedForm.integrationSettings?.sedgwick?.registrationPayload || {}
			}
		};
		this.handleChange({ integrationSettings: newIntegrationSettings });
		this.toggleSedgwickConfigModal();
	};

	renderIntegrationsSection = () => {
		const { editedForm, formIntegrations, formFieldOptions } = this.state;
		const integrationSettings = editedForm.integrationSettings || {};
		return (
			<div className='blocksContainer-Advanced'>
				<div className="sectionBlock mr-25 contained-Advanced">
					<h2 className='blockHeader'>Configure Connected Integrations</h2>
					{formIntegrations.map((integration, index) => {
						switch (integration.identifier) {
							case 'sedgwick': {
								const sedgwickSettings = integrationSettings.sedgwick || { enabled: false, registrationPayload: {} };
								const registrationPayload = sedgwickSettings.registrationPayload || {};
								const regionOptions = [{ value: 'US', label: 'North America' }, { value: 'EU', label: 'Global' }];
								return (
									<div key={index}>
										<h3 className='blockSubHeader'>Sedgwick</h3>
										<ToggleField
											label="Capture Attendee Information for Sedgwick"
											checked={sedgwickSettings.enabled || false}
											icons={false}
											onChange={(e) => {
												this.handleSedgwickToggle(e.target.checked);
											}}
										/>
										{sedgwickSettings.enabled && (
											<div className="mt-20">
												<h4 className='formFieldLabel mb-10'>Field Mapping</h4>
												<p className="mb-20">Map your form fields to Sedgwick required fields:</p>
												<SelectField
													label="Registration Region"
													options={regionOptions}
													value={regionOptions.find(f => f.value === registrationPayload.RegistrationRegion)}
													onChange={(e) => this.handleIntegrationFieldMapping('sedgwick', 'RegistrationRegion', e.value)}
												/>
												<InputField
													label="Recall Event ID"
													value={registrationPayload.RecallEventID || ''}
													onChange={(e) => this.handleIntegrationFieldMapping('sedgwick', 'RecallEventID', e.target.value)}
												/>
												<InputField
													label="Registration Type ID"
													value={registrationPayload.RegistrationTypeId || ''}
													onChange={(e) => this.handleIntegrationFieldMapping('sedgwick', 'RegistrationTypeId', e.target.value)}
												/>
												<SelectField
													label="First Name"
													options={formFieldOptions}
													value={formFieldOptions.find(f => f.value === registrationPayload.FirstName)}
													onChange={(e) => this.handleIntegrationFieldMapping('sedgwick', 'FirstName', e.value)}
												/>

												<SelectField
													label="Last Name"
													options={formFieldOptions}
													value={formFieldOptions.find(f => f.value === registrationPayload.LastName)}
													onChange={(e) => this.handleIntegrationFieldMapping('sedgwick', 'LastName', e.value)}
												/>

												<SelectField
													label="Email"
													options={formFieldOptions}
													value={formFieldOptions.find(f => f.value === registrationPayload.Email)}
													onChange={(e) => this.handleIntegrationFieldMapping('sedgwick', 'Email', e.value)}
												/>

												<SelectField
													label="Phone"
													options={formFieldOptions}
													value={formFieldOptions.find(f => f.value === registrationPayload.Phone)}
													onChange={(e) => this.handleIntegrationFieldMapping('sedgwick', 'Phone', e.value)}
												/>

												<SelectField
													label="Address 1"
													options={formFieldOptions}
													value={formFieldOptions.find(f => f.value === registrationPayload.Address1)}
													onChange={(e) => this.handleIntegrationFieldMapping('sedgwick', 'Address1', e.value)}
												/>

												<SelectField
													label="Address 2"
													options={formFieldOptions}
													value={formFieldOptions.find(f => f.value === registrationPayload.Address2)}
													onChange={(e) => this.handleIntegrationFieldMapping('sedgwick', 'Address2', e.value)}
												/>

												<SelectField
													label="City"
													options={formFieldOptions}
													value={formFieldOptions.find(f => f.value === registrationPayload.City)}
													onChange={(e) => this.handleIntegrationFieldMapping('sedgwick', 'City', e.value)}
												/>

												<SelectField
													label="State/Province"
													options={formFieldOptions}
													value={formFieldOptions.find(f => f.value === registrationPayload.StateProvince)}
													onChange={(e) => this.handleIntegrationFieldMapping('sedgwick', 'StateProvince', e.value)}
												/>

												<SelectField
													label="Postal Code"
													options={formFieldOptions}
													value={formFieldOptions.find(f => f.value === registrationPayload.Postal)}
													onChange={(e) => this.handleIntegrationFieldMapping('sedgwick', 'Postal', e.value)}
												/>

												<SelectField
													label="Country ISO2"
													options={formFieldOptions}
													value={formFieldOptions.find(f => f.value === registrationPayload.CountryISO2)}
													onChange={(e) => this.handleIntegrationFieldMapping('sedgwick', 'CountryISO2', e.value)}
												/>

												<SelectField
													label="Language Preference"
													options={formFieldOptions}
													value={formFieldOptions.find(f => f.value === registrationPayload.LanguagePreference)}
													onChange={(e) => this.handleIntegrationFieldMapping('sedgwick', 'LanguagePreference', e.value)}
												/>

												<h4 className='formFieldLabel mt-20 mb-10'>Extended Properties</h4>

												<SelectField
													label="Job Title"
													options={formFieldOptions}
													value={formFieldOptions.find(f => f.value === registrationPayload.ExtendedProperties?.JobTitle)}
													onChange={(e) => this.handleIntegrationFieldMapping('sedgwick', 'ExtendedProperties.JobTitle', e.value)}
												/>

												<SelectField
													label="Company Name"
													options={formFieldOptions}
													value={formFieldOptions.find(f => f.value === registrationPayload.ExtendedProperties?.CompanyName)}
													onChange={(e) => this.handleIntegrationFieldMapping('sedgwick', 'ExtendedProperties.CompanyName', e.value)}
												/>

												<SelectField
													label="Distributed To Other Orgs"
													options={formFieldOptions}
													value={formFieldOptions.find(f => f.value === registrationPayload.ExtendedProperties?.DistributedToOtherOrgs)}
													onChange={(e) => this.handleIntegrationFieldMapping('sedgwick', 'ExtendedProperties.DistributedToOtherOrgs', e.value)}
												/>

												<SelectField
													label="Customer Acknowledged"
													options={formFieldOptions}
													value={formFieldOptions.find(f => f.value === registrationPayload.ExtendedProperties?.CustomerAcknowledged)}
													onChange={(e) => this.handleIntegrationFieldMapping('sedgwick', 'ExtendedProperties.CustomerAcknowledged', e.value)}
												/>
											</div>
										)}
									</div>
								);
							}
							default:
								return <div key={index}></div>;
						}
					})}
					{(() => {
						const inventorySettings = integrationSettings.inventory || {
							enabled: false,
							inventoryUnavailableMessage: {},
							conditionalField: ''
						};

						// Filter to only show form fields
						const formOnlyFields = formFieldOptions.filter(f => f.type === 'form');

						// Helper to get field ID without "form." prefix
						const getFieldId = (value) => {
							if (!value) return '';
							return value.startsWith('form.') ? value.substring(5) : value;
						};

						// Helper to add "form." prefix if not present
						const addFormPrefix = (value) => {
							if (!value) return '';
							return value.startsWith('form.') ? value : `form.${value}`;
						};

						return (
							<div>
								<h3 className='blockSubHeader'>Inventory</h3>
								<ToggleField
									label="Enable Inventory Settings"
									checked={inventorySettings.enabled || false}
									icons={false}
									onChange={(e) => {
										const newIntegrationSettings = {
											...integrationSettings,
											inventory: {
												...inventorySettings,
												enabled: e.target.checked
											}
										};
										this.handleChange({ integrationSettings: newIntegrationSettings });
									}}
								/>
								{inventorySettings.enabled && (
									<div className="mt-20">
										<h4 className='formFieldLabel mb-10'>Conditional Field</h4>
										<p className="mb-15" style={{ fontSize: '0.9em', color: '#666' }}>
											Select a form field to determine which custom message to display when inventory is full.
										</p>

										<SelectField
											label="Conditional Field"
											options={formOnlyFields}
											value={formOnlyFields.find(f => f.value === addFormPrefix(inventorySettings.conditionalField))}
											onChange={(e) => {
												const newIntegrationSettings = {
													...integrationSettings,
													inventory: {
														...inventorySettings,
														conditionalField: getFieldId(e.value)
													}
												};
												this.handleChange({ integrationSettings: newIntegrationSettings });
											}}
											placeholder="Select a form field..."
										/>

										{inventorySettings.conditionalField && (
											<div className="mt-20">
												<h4 className='formFieldLabel mb-10'>Inventory Unavailable Messages</h4>
												<p className="mb-15" style={{ fontSize: '0.9em', color: '#666' }}>
													Add custom messages for different values of the selected field. For example, if the field is "Language", you can add messages for "spanish", "english", etc.
												</p>

												{Object.keys(inventorySettings.inventoryUnavailableMessage || {}).map((fieldValue, idx) => (
													<div key={idx} className="mb-15 p-15" >
														<div className="flex-ac mb-10">
															<InputField
																label="Field Value (e.g., spanish, english, VIP)"
																value={fieldValue}
																onChange={(e) => {
																	const newMessages = { ...inventorySettings.inventoryUnavailableMessage };
																	const message = newMessages[fieldValue];
																	delete newMessages[fieldValue];
																	newMessages[e.target.value] = message;

																	const newIntegrationSettings = {
																		...integrationSettings,
																		inventory: {
																			...inventorySettings,
																			inventoryUnavailableMessage: newMessages
																		}
																	};
																	this.handleChange({ integrationSettings: newIntegrationSettings });
																}}
																placeholder="e.g., spanish, VIP, general"
															/>
															<i
																className='las la-times ml-10 c-pointer'
																style={{ fontSize: '24px', color: '#dc3545' }}
																onClick={() => {
																	const newMessages = { ...inventorySettings.inventoryUnavailableMessage };
																	delete newMessages[fieldValue];

																	const newIntegrationSettings = {
																		...integrationSettings,
																		inventory: {
																			...inventorySettings,
																			inventoryUnavailableMessage: newMessages
																		}
																	};
																	this.handleChange({ integrationSettings: newIntegrationSettings });
																}}
															/>
														</div>
														<RichTextEditor
															id={`Inventory_Message_${idx}`}
															label="Custom Message"
															placeholder="Message to display when inventory is full for this field value..."
															value={inventorySettings.inventoryUnavailableMessage[fieldValue] || ''}
															onChange={(value) => {
																const newMessages = {
																	...inventorySettings.inventoryUnavailableMessage,
																	[fieldValue]: value
																};

																const newIntegrationSettings = {
																	...integrationSettings,
																	inventory: {
																		...inventorySettings,
																		inventoryUnavailableMessage: newMessages
																	}
																};
																this.handleChange({ integrationSettings: newIntegrationSettings });
															}}
															customFields={this.state.customFields}
														/>
													</div>
												))}

												<div
													className="c-pointer flex jcc mt-15"
													style={{ color: '#007bff', fontWeight: 500 }}
													onClick={() => {
														const newMessages = {
															...inventorySettings.inventoryUnavailableMessage,
															'': ''
														};

														const newIntegrationSettings = {
															...integrationSettings,
															inventory: {
																...inventorySettings,
																inventoryUnavailableMessage: newMessages
															}
														};
														this.handleChange({ integrationSettings: newIntegrationSettings });
													}}
												>
													+ Add Message for Field Value
												</div>
											</div>
										)}
									</div>
								)}
							</div>
						);
					})()}
				</div>
			</div>
		);
	};

	renderSubmissionsSection = () => {
		const { editedForm, form } = this.state;
		const { event } = this.props;

		return (
			<FormSubmissions
				event={event}
				editedForm={editedForm}
				form={form}
				orgId={this.props.orgId}
				eventId={this.props.eventId}
				toggleSubmissionEditing={this.toggleSubmissionEditing}
			/>
		);
	};

	renderSection = () => {
		const { selectedSection } = this.state;

		switch (selectedSection) {
			case 'settings':
				return this.renderSettingsSection();
			case 'advanced':
				return this.renderAdvancedSection();
			case 'integrations':
				return this.renderIntegrationsSection();
			case 'submissions':
				return this.renderSubmissionsSection();
			default:
				return this.renderSettingsSection();
		}
	};

	toggleDuplicateFormModal = () => {
		const { toggleDuplicateFormModal } = this.state;
		this.setState({ toggleDuplicateFormModal: !toggleDuplicateFormModal })
	}

	toggleAddToPage = () => {
		const { toggleAddToPage } = this.state;
		this.setState({ toggleAddToPage: !toggleAddToPage })

	}
	toggleRenameForm = () => {
		const { toggleRenameForm } = this.state;
		this.setState({ toggleRenameForm: !toggleRenameForm })
	}
	toggleScheduleClose = () => {
		const { toggleScheduleClose } = this.state;
		this.setState({ toggleScheduleClose: !toggleScheduleClose })
	}
	toggleCloseNow = () => {
		const { toggleCloseNow } = this.state;
		this.setState({ toggleCloseNow: !toggleCloseNow })
	}

	updateCloseStatus = (properties, callback) => {
		const { form, editedForm } = this.state;
		this.setState({ form: { ...form, ...properties }, editedForm: { ...editedForm, ...properties }, editCount: this.state.editCount + 1 }, () => {

			callback && callback();

		});
	}

	toggleDeleteForm = () => {
		const { toggleDeleteForm } = this.state;
		this.setState({ toggleDeleteForm: !toggleDeleteForm })
	}

	toggleDeleteSubmission = () => {
		const { toggleDeleteSubmission } = this.state;
		this.setState({ toggleDeleteSubmission: !toggleDeleteSubmission })
	}

	handleJoyrideCallback = (data) => {
		const { status } = data;
		const finishedStatuses = ['finished', 'skipped'];
		if (finishedStatuses.includes(status)) {
			this.setState({ runPageTutorial: false });
		}
	};

	startTour = () => {
		this.setState({ runPageTutorial: true });
	};

	render() {
		const { form,
			loading,
			selectedSection,
			editedForm,
			editing,
			editingFormBuilder,
			toggleDuplicateFormModal,
			selectedEmbedPagePreview,
			toggleAddToPage,
			isV1,
			toggleRenameForm,
			toggleScheduleClose,
			toggleCloseNow,
			toggleDeleteForm,
			toggleDeleteSubmission,
			runPageTutorial,
			tabs
		} = this.state;

		const { event, orgId } = this.props;
		let selectedDate = new Date(form.closeAt) ? new Date(form.closeAt) : null;
		let currentTimeDate = new Date(moment().tz(event.timezone).format('MM/DD/YYYY hh:mm a'));

		let isFormClosed = false;
		let formClosedMessage = '';
		if (form.closed) {
			isFormClosed = form.closed;
			formClosedMessage = 'This Form has been closed';
		}
		if (form.closeAt) {
			if (selectedDate <= currentTimeDate) {
				isFormClosed = true;
				formClosedMessage = 'This form is now closed as of ' + moment(selectedDate).tz(event.timezone).format('MM/DD/YYYY hh:mm a');
			} else {
				formClosedMessage = 'This form is scheduled to close on ' + moment(selectedDate).tz(event.timezone).format('MM/DD/YYYY hh:mm a');
			}
		}
		let subActions = form.closeAt && isFormClosed ? [
			{
				label: <span><i className='las la-pen mr-10'></i>Rename Form</span>,
				onClick: this.toggleRenameForm
			},
			{
				label: <span><i className='las la-copy mr-10'></i>Duplicate Form</span>,
				onClick: this.toggleDuplicateFormModal
			},
			{
				label: <span><i className='las la-lock-open mr-10'></i>Open Form Now</span>,
				onClick: this.toggleCloseNow
			},
			{
				label: <span><i className='las la-trash mr-10'></i>Delete Form</span>,
				onClick: this.toggleDeleteForm
			}

		] : isFormClosed ? [
			{
				label: <span><i className='las la-pen mr-10'></i>Rename Form</span>,
				onClick: this.toggleRenameForm
			},
			{
				label: <span><i className='las la-copy mr-10'></i>Duplicate Form</span>,
				onClick: this.toggleDuplicateFormModal
			},
			{
				label: <span><i className='las la-lock-open mr-10'></i>Open Form Now</span>,
				onClick: this.toggleCloseNow
			},
			{
				label: <span><i className='las la-trash mr-10'></i>Delete Form</span>,
				onClick: this.toggleDeleteForm
			}

		] : !isFormClosed ? [
			{
				label: <span><i className='las la-pen mr-10'></i>Rename Form</span>,
				onClick: this.toggleRenameForm
			},
			{
				label: <span><i className='las la-copy mr-10'></i>Duplicate Form</span>,
				onClick: this.toggleDuplicateFormModal
			},
			{
				label: <span><i className='las la-lock mr-10'></i>Close Form Now</span>,
				onClick: this.toggleCloseNow
			},
			{
				label: <span><i className={`${!form.closeAt ? 'las la-calendar-plus' : 'las la-calendar-minus'} mr-10`}></i>{form.closeAt ? 'Unschedule Close Form' : 'Schedule Close Form'}</span>,
				onClick: this.toggleScheduleClose
			},
			{
				label: <span><i className='las la-trash mr-10'></i>Delete Form</span>,
				onClick: this.toggleDeleteForm
			}
		] : []

		const currentForm = this.props.forms.find(form => form._id === this.props.match.params.formId);

		let hasSalesforceFields = false;
		if (editedForm && editedForm.pages) {
			editedForm.pages.forEach(page => {
				page.sections.forEach(section => {
					section.fields.forEach(field => {
						if (field.type && (field.type === 'salesForceSearchContact' || field.type === "salesForceSearchAccount")) {
							hasSalesforceFields = true;
						}
					});
				});
			});
		}
		const hasSalesforceIntegration = event.integrations && event.integrations.salesforce ? true : false;
		const salesforceLeadEnabled = editedForm ? editedForm.salesforceLeadEnabled : false;
		const showAlertBar = hasSalesforceIntegration && (!salesforceLeadEnabled && !hasSalesforceFields);
		return (
			<div className="sectionContainer">
				{!loading && showAlertBar && <AlertBar style={{ background: '#b90000' }} message={"This form is not connected to Salesforce and is not sending attendee data."} type="error" />}

				{!loading && (
					<Joyride
						callback={this.handleJoyrideCallback}
						continuous
						run={runPageTutorial}
						scrollOffset={64}
						scrollToFirstStep
						showProgress={false}
						hideCloseButton={false}
						showSkipButton
						steps={tutorials['Form']}
						styles={{
							buttonNext: {
								background: 'var(--primary)',
								border: 'var(--primary--border)',
								color: 'var(--white)',
								fontWeight: 600,
								padding: '10px 15px',
								fontSize: 14,
								width: 65,
								height: 30,
							},
							buttonSkip: {
								background: 'var()',
								border: 'var(--primary--border)',
								color: 'var(--primary)',
								fontWeight: 600,
								padding: '10px 15px',
								fontSize: 14,
							},
							buttonBack: {
								color: "#007bff",
							},
						}}
					/>
				)}

				{<SectionHeader
					style={!loading && showAlertBar ? { marginTop: 20 } : {}}
					title={currentForm ? currentForm.name : editedForm.name}
					description={`Insightful description**`}
					breadcrumbs={[
						{
							name: event.name
						},
						{
							name: 'Forms'
						}
					]}
					subActions={subActions}
				>
					<TabContainer
						tabs={tabs}
						updateSelected={this.updateSelected}
						selectedIndex={tabs.findIndex((t) => t.id === selectedSection)}
					/>
				</SectionHeader>}

				{!loading && !isV1 &&
					<div className='flex aic'>

						{selectedSection === 'settings' && <div className="mainActionContainer mt-20" style={{ marginLeft: 'unset' }}>
							<button className={`prim`}
								disabled={false}
								onClick={() => {
									if (!selectedEmbedPagePreview) {
										this.toggleAddToPage();
									}
									else {
										this.props.history.push(`/${orgId}/events/${event._id}/pages/${selectedEmbedPagePreview.value}`);
									}
								}}>
								<div>{!selectedEmbedPagePreview ? "Add to Page" : "View Page"}</div>
							</button>

						</div>}
						{formClosedMessage && <p className='ml-10 flex aic mt-20'>{formClosedMessage}</p>}
					</div>}
				{!loading && <div className="sectionBody">{this.renderSection()}</div>}
				{!loading && (selectedSection !== 'submissions' ?
					<SectionFooter updatedAt={form.updatedAt} saveEdit={this.saveForm} cancelEdit={this.cancelEdit} editing={editing} lastEditedBy={editedForm.lastEditedBy} /> :
					<ActionButtonContainer
						batchActions={[{
							type: 'button',
							label: 'Delete Submission',
							iconClass: 'las la-trash-alt',
							class: 'danger',
							onClick: this.toggleDeleteSubmission
						}]}
						checkedEntryCount={Object.keys(this.state.checkedSubmission).length}
						entriesLength={editedForm.submissions ? editedForm.submissions.length : 0}
						uncheckEntries={this.cancelSubmissionEdit}
					/>)
				}
				<FormBuilderModal
					isOpen={this.state.formEditorModalOpen}
					editing={editingFormBuilder}
					toggle={this.toggleFormEditorModal}
					form={form}
					editedForm={editedForm}
					fields={this.props.fields}
					baseFieldList={[...this.state.baseFieldList]}
					customFieldList={[...this.state.customFields]}
					links={{ get: `` }}
					updateForm={this.updateForm}
					cancelEdit={this.cancelEdit}
					emails={this.props.availableEmails}
					orgId={this.props.orgId}
					eventId={this.props.eventId}
					addNewField={this.props.addNewField}
					saveForm={this.saveForm}
					customFields={this.state.metadataOptions}
					groups={this.props.event.groups}
					pages={this.state.pages}
					allPages={this.state.allPages}
					updateCustomFields={this.updateCustomFields}
					inventory={this.state.inventory}
				/>

				{toggleDeleteSubmission && <DeleteSubmissionModal
					toggle={this.toggleDeleteSubmission}
					isOpen={toggleDeleteSubmission}
					deleteSubmission={this.deleteFormSubmission}
					selectedSubmissionCount={Object.keys(this.state.checkedSubmission).length}
				/>}
				{toggleRenameForm && <RenameFormModal
					toggle={this.toggleRenameForm}
					isOpen={toggleRenameForm}
					name={form.name}
					formId={form._id}
					form={editedForm}
					eventId={event._id}
					orgId={orgId}
					update={this.updateFormName}
				/>}

				{toggleAddToPage &&
					<AddToPage
						toggle={this.toggleAddToPage}
						isOpen={toggleAddToPage}
						pages={this.state.pages}
						updateAddToPage={this.updateAddToPage}
					/>}

				{toggleDuplicateFormModal && <DuplicateFormModal
					toggle={this.toggleDuplicateFormModal}
					isOpen={toggleDuplicateFormModal}
					name={form.name}
					formId={form._id}
					eventId={event._id}
					orgId={orgId}

				/>}

				{toggleCloseNow &&
					<CloseFormNowModal
						toggle={this.toggleCloseNow}
						isOpen={toggleCloseNow}
						formId={form._id}
						eventId={event._id}
						updateCloseStatus={this.updateCloseStatus}
						orgId={orgId}
						isFormClosed={isFormClosed}
					/>
				}
				{toggleScheduleClose &&
					<ScheduleCloseFormModal
						toggle={this.toggleScheduleClose}
						isOpen={toggleScheduleClose}
						formId={form._id}
						eventId={event._id}
						orgId={orgId}
						isScheduled={form.closeAt}
						event={event}
						updateCloseStatus={this.updateCloseStatus}
					/>
				}

				{toggleDeleteForm && (
					<DeleteFormModal
						isOpen={toggleDeleteForm}
						delete={this.deleteCheckedForms}
						form={form}
						toggle={this.toggleDeleteForm}
						count={1}
						isMultiple={false}
						removeForm={this.props.deleteSingleForm}
					/>
				)}

				{this.state.showSedgwickConfigModal && (
					<SedgwickConfigModal
						isOpen={this.state.showSedgwickConfigModal}
						toggle={this.toggleSedgwickConfigModal}
						orgId={this.props.orgId}
						eventId={this.props.eventId}
						currentFormId={form._id}
						formFieldOptions={this.state.formFieldOptions}
						onApply={this.applySedgwickConfig}
						onSkip={this.skipSedgwickConfig}
					/>
				)}

				<LoadingWizard text={'Loading Form'} loading={loading} />
			</div>
		);
	}
}

export default withRouter(Form);
